
<app-common-modal #editAccessoryModal [name]="'addAccessory'" [title]=" " [twoButtonsDialogs]="true" [withFooter]="false">
  <h4 class="modal-title" modal-title translate>T_OFFER_DATA_MANAGEMENT_ACCESSORY_INFORMATION</h4>
  <div modal-body>

    <h5 translate>T_ACCESSORY_CATEGORY</h5>
    <p-dropdown
      [(ngModel)]="editAccessoryForm.categoryId"
      [autoDisplayFirst]="false"
      [options]="availableCategories"
      optionLabel="nameTranslated"
      optionValue="id"
      scrollHeight="150px"
      styleClass="dropdown-large">
    </p-dropdown>

    <h5 *ngIf="displayName()"  translate>T_ACCESSORY_NAME</h5>
    <div *ngFor="let item of editAccessoryForm.name | keyvalue; trackBy: trackByFn" class="edit-accessory-name">
      {{item.key}}: <input [(ngModel)]="editAccessoryForm.name[item.key]" class="edit-accessory-name-input" type="text" />
    </div>

    <h5 *ngIf="displayDescription()" translate>T_ACCESSORY_DESCRIPTION</h5>
    <div *ngFor="let item of editAccessoryForm.description | keyvalue; trackBy: trackByFn" class="edit-accessory-name">
      {{item.key}}: <input [(ngModel)]="editAccessoryForm.description[item.key]" class="edit-accessory-name-input" type="text" />
    </div>

    <h5 class="checkbox-mandatory" translate>
      <div>
        <label class="custom-checkbox-container">
          <input [(ngModel)]="editAccessoryForm.required" class="checkbox" name="mandatoryAccessory" type="checkbox">
          <span class="checkmark"></span>
        </label>
      </div>
      T_ADMIN_OFFER_DATA_MANAGEMENT_ACCESSORY_MANDATORY
    </h5>

    <div *ngIf="enableDefaultValueManagement()">
      <h5 translate>T_ACCESSORY_DEFAULT_VALUE</h5>
      <p-dropdown
        [(ngModel)]="editAccessoryForm.defaultValue"
        [options]="accessoryValues"
        autoDisplayFirst="false"
        optionLabel="nameTranslated"
        optionValue="id"
        scrollHeight="150px"
        styleClass="dropdown-small">
      </p-dropdown>
    </div>

    <h5 translate>T_ACCESSORY_HTML_TYPE</h5>
    <p-selectButton [(ngModel)]="editAccessoryForm.htmlElementType" [options]="elementTypeOptions" optionLabel="name" optionValue="code"></p-selectButton>

    <div class="edit-accessory-modal-footer">
      <button (click)="hide()" class="btn btn-default-white-background" translate>T_BUTTON_CANCEL</button>
      <button (click)="clickOnSaveAccessory(); hide()" [disabled]="!isValidForm()" class="btn btn-default-white-background" translate>T_OFFER_DATA_MANAGEMENT_SAVE_ACCESSORY_BUTTON</button>
    </div>
  </div>

</app-common-modal>
